import { RootState } from 'src/state/rootReducer';

export const getCommandsList = (state: RootState) => {
  return state.entities.commands;
};
